<template>
  <el-config-provider :locale="zhCn">
    <!-- <MainLayout/> -->
    <component :is="currentLayout"></component>
  </el-config-provider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from 'element-plus'
// import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import CommonService from './apis/CommonService';

// import MainLayout from './views/Layout/MainLayout.vue'

const DefaultLayout = defineAsyncComponent(() => import('./views/Layout/MainLayout.vue'));
const AiLayout = defineAsyncComponent(() => import('./views/Layout/AiLayout.vue'));

const route = useRoute();
const router = useRouter()
// 核心判断：仅根据路由是否以/ai/开头切换布局，不修改任何路由配置
const currentLayout = computed(() => {
  // 严格匹配以/ai/开头的路由（比如/ai/dashboard、/ai/model，不含/ai本身）
  return route.path.startsWith('/ai') ? AiLayout : DefaultLayout;
});


onMounted(async () => {
  // 等待页面加载完成
  await router.isReady()
  // 首次加载上报
  CommonService.recordAccess(router.currentRoute.value.fullPath)

  // 路由切换监听
  watch(
    () => router.currentRoute.value.fullPath,
    (path) => CommonService.recordAccess(path)
  )
})
</script>